var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"swiper-container"},[_c('div',{staticClass:"swiper-wrapper"},_vm._l((_vm.banner),function(item,index){return _c('div',{key:index,staticClass:"swiper-slide slide"},[_c('a',{attrs:{"href":item.web_url}},[_c('img',{attrs:{"src":item.wap}})])])})),_vm._v(" "),_c('div',{staticClass:"swiper-pagination bullet"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e395607","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index/components/swiper.vue
// module id = null
// module chunks = 